
import React from "react";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { connect } from "react-redux";
import { actionCreators} from '../Kanban/action';
import TableChartIcon from '@material-ui/icons/TableChart';
import { useRouteMatch } from "react-router-dom";
import isMobile from "../../helpers/isMobile";
import IconButton from '@material-ui/core/IconButton';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';

const SwitchKanban = props => {

  const isInProject = useRouteMatch("/project/:projectId");

  return isInProject && ( !props.isKanban ? (
  <IconButton 
  
   aria-label="bullet list" 
   component="span"  
   color="inherit"
   onClick={() => props.kanban()}>
     <FormatListBulletedIcon />
 </IconButton>
) : (
 <IconButton 

 aria-label="kanban board" 
 component="span" 
 color="inherit" 
 onClick={() => props.kanban()}>
   <TableChartIcon  />
</IconButton>
 
))}

const mapStateToProps = state => {

  return {
    isKanban: state.kanban
  };
};

export default connect(mapStateToProps, actionCreators)(SwitchKanban);
